import { Route } from '@angular/router';
import { LayoutComponent } from '@ipensii/layout/ui-layout';
import { Error404Component, NotFoundComponent } from '@ipensii/error/ui-error';
import { AdminPath } from '@ipensii/admin/domain-admin';
import { AuthPath } from '@ipensii/auth/domain-auth';
import { ErrorPath } from '@ipensii/error/domain-error';
import { EmployerPath } from '@ipensii/employer/domain-employer';
import { shellAuthRoutes } from '@ipensii/auth/shell-auth';

export const ipensiiAppRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', loadChildren: () => import('@ipensii/fund/feature-fund-picker').then((m) => m.featurePickerRoutes) },
      ...shellAuthRoutes,
    ],
  },
  {
    path: AdminPath.admin,
    loadChildren: () => import('@ipensii/admin/shell-admin').then((m) => m.shellAdminRoutes),
  },
  {
    path: `${EmployerPath.employer}`,
    loadChildren: () => import('@ipensii/employer/shell-employer').then((m) => m.shellEmployerRoutes),
  },
  {
    path: AuthPath.loggin,
    loadChildren: () => import('@ipensii/auth/feature-loggin').then((m) => m.featureLogginRoutes),
  },
  { path: ErrorPath.error, component: Error404Component },
  { path: ErrorPath.notfound, component: NotFoundComponent },
  { path: '**', redirectTo: `/${ErrorPath.notfound}` },
];
